export type DmAttachmentKind = 'image' | 'video' | 'audio' | 'file';

const MEDIA_KINDS = new Map<string, DmAttachmentKind>([
    ['image', 'image'],
    ['video', 'video'],
    ['audio', 'audio']
]);

const KNOWN_TYPE_LABELS = new Map<string, string>([
    ['application/pdf', 'PDF'],
    ['model/stl', 'STL'],
    ['application/sla', 'STL'],
    ['application/vnd.ms-pki.stl', 'STL'],
    ['application/dicom', 'DICOM'],
    ['application/zip', 'ZIP'],
    ['text/plain', 'TXT'],
    ['application/octet-stream', 'FILE']
]);

const FALLBACK_TYPE_LABEL = 'FILE';
const MAX_DERIVED_LABEL_LENGTH = 6;

function essence(mimeType: string): string {
    return mimeType.split(';')[0].trim().toLowerCase();
}

export function getAttachmentKind(mimeType: string): DmAttachmentKind {
    const topLevel = essence(mimeType).split('/')[0];
    return MEDIA_KINDS.get(topLevel) ?? 'file';
}

// "application/x-foo" → "FOO", "application/vnd.bar+xml" → "XML"; long or odd subtypes → "FILE".
export function getAttachmentTypeLabel(mimeType: string): string {
    const normalized = essence(mimeType);
    const known = KNOWN_TYPE_LABELS.get(normalized);
    if (known) return known;

    const subtype = (normalized.split('/')[1] ?? '').replace(/^(x-|vnd\.)/, '');
    const lastToken = subtype.split(/[.+]/).pop() ?? '';
    const isShortAlnum =
        /^[a-z0-9]+$/.test(lastToken) && lastToken.length <= MAX_DERIVED_LABEL_LENGTH;
    return isShortAlnum ? lastToken.toUpperCase() : FALLBACK_TYPE_LABEL;
}
